<template>
  <div class="splash center pa-6" style="background-color: #26252b">
    <v-main>
      <h1 style="color: white" justify="center" align="center">
        سامانه وبکارت
      </h1>
      <div class="center mt-3">
        <v-progress-linear
          v-if="visibleProgress"
          style="width: 25%"
          indeterminate
          color="cyan"
        ></v-progress-linear>
        <strong v-if="visibleError" class="error--text">{{ errorMsg }}</strong>
      </div>
    </v-main>
    <!-- <setting-api-dialog ref="SettingApiDialog" @refresh="checkBaseUrl" /> -->
  </div>
</template>

<script>
//import SettingApiDialog from "../components/auth/SettingApiDialog.vue";
import EosToastType from "../model/EosToastType";
import ResultType from "../model/ResultType";

export default {
  //components: { SettingApiDialog },
  data() {
    return {
      visibleProgress: false,
      visibleError: false,
      errorMsg: "",
    };
  },
  created() {
    this.timer();
  },
  methods: {
    timer() {
      this.visibleError = false;
      this.visibleProgress = true;

      setTimeout(() => {
        this.pageLoad();
      }, 500);
    },
    pageLoad() {
      this.checkBaseUrl();
    },
    async checkBaseUrl() {
      //debugger
      var canConnectRes = await this.$store.dispatch("EosTestConnection");
      //console.log(canConnectRes);
      //debugger
      if (canConnectRes.type === ResultType.success) {
        this.$router.push({ name: "login" });
      } else {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: "آدرس سرور نادرست می باشد",
        });
        this.visibleError = true;
        this.visibleProgress = false;
        this.errorMsg = "آدرس سرور نادرست می باشد";
      }
    },
    //  checkBaseUrl() {
    //   //debugger
    //   var canConnectRes =  this.$store.dispatch("EosTestConnection");
    //   //console.log(canConnectRes);
    //   //debugger
    //   if (canConnectRes.type === ResultType.success) {
    //     this.$router.push({ name: "login" });
    //   } else {
    //     this.$EosToast.show({
    //       type: EosToastType.error,
    //       msg: "آدرس سرور نادرست می باشد",
    //     });
    //     this.visibleError = true;
    //     this.visibleProgress = false;
    //     this.errorMsg = "آدرس سرور نادرست می باشد";
    //   }
    // },
  },
};
</script>

<style>
.splash {
  height: 100vh;
}

.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>